import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const useStyles = makeStyles(() => ({
  content: {
    overflow: "auto",
    overflowX: "hidden",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    height: "100%",
    overscrollBehaviorX: "none",
  },
}));

const TicketAdvanced = () => {
  const classes = useStyles();
  const { ticketId } = useParams();
  const { setCurrentTicket } = useContext(TicketsContext);

  useEffect(() => {
    return () => {
      setCurrentTicket({ id: null, code: null });
    };
  }, [setCurrentTicket]);

  const hasTicketOpen = ticketId && ticketId !== "undefined";

  return (
    <QueueSelectedProvider>
      <TicketAdvancedLayout className="tickets-wrapper">
        <Box className={classes.content}>
          {hasTicketOpen ? <Ticket /> : <TicketsManagerTabs />}
        </Box>
      </TicketAdvancedLayout>
    </QueueSelectedProvider>
  );
};

export default TicketAdvanced;
